type ApiErrorPayload = {
  message?: string;
  error?: string;
  errors?: Record<string, string | string[]>;
};

type LoginPayload = {
  token?: string;
  access_token?: string;
  data?: {
    token?: string;
    access_token?: string;
  };
};

const getApiBaseUrl = () => {
  const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL?.replace(/\/$/, '');

  if (!baseUrl) throw new Error('API service URL is not configured.');

  return baseUrl;
};

const getErrorMessage = (payload: unknown) => {
  if (!payload || typeof payload !== 'object') return undefined;

  const { message, error, errors } = payload as ApiErrorPayload;
  if (message) return message;
  if (error) return error;

  const firstError = errors && Object.values(errors).flat()[0];
  return typeof firstError === 'string' ? firstError : undefined;
};

export const login = async (email: string, password: string) => {
  const response = await fetch(`${getApiBaseUrl()}/web/auth/login`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
  });
  const payload = (await response.json().catch(() => null)) as LoginPayload | ApiErrorPayload | null;

  if (!response.ok) throw new Error(getErrorMessage(payload) ?? 'Login failed.');

  const loginPayload = payload as LoginPayload;
  const token = loginPayload?.token ?? loginPayload?.access_token ?? loginPayload?.data?.token ?? loginPayload?.data?.access_token;

  if (!token) throw new Error('Login response did not include an access token.');

  return token;
};

export const logout = () => {
  window.localStorage.removeItem('auth_token');
  window.sessionStorage.removeItem('auth_token');
};

